import React from 'react';
import PropTypes from 'prop-types';
import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';

const PenlySeo = ({ title, description, image, noindex, url }) => {
    const router = useRouter();
    const defaultImage = 'https://penly.dk/static/gfx/content/penly-content-hero-1.jpg';

    let parsedImage = image;
    if (!image || image.url.endsWith('.svg')) {
        parsedImage = defaultImage;
    } else if (!image.url.startsWith('http')) {
        parsedImage = { url: `https://penly.dk${image.url}` };
    }

    let parsedUrl = url;

    if (url) {
        parsedUrl = `https://penly.dk${parsedUrl}`;
    } else if (!url && router?.pathname) {
        parsedUrl = `https://penly.dk${router.pathname}`;
    } else {
        parsedUrl = '`https://penly.dk';
    }

    return (
        <NextSeo
            title={ title }
            description={ description }
            noindex={ noindex }
            openGraph={{
                url: parsedUrl,
                description,
                images: [{ url: parsedImage.url }],
            }}
        />
    );
};

PenlySeo.defaultProps = {};

PenlySeo.propTypes = {};

export default PenlySeo;
